'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');let

ProfileController=class ProfileController extends BaseController{
static get $inject(){
return['userService','uncaughtErrorHandler','breadcrumbsService'];
}

constructor(userService,uncaughtErrorHandler,breadcrumbsService){
super(uncaughtErrorHandler);

this._userService=userService;

breadcrumbsService.startTrail('Profile');
}

get isCurrentUserPrimary(){
return _.get(this._userService,'currentUser.isPrimary');
}};


module.exports=ProfileController;
//# sourceMappingURL=profileController.js.map
